import React, { FC } from 'react'
import { Button, Chip, Grid } from '@mui/material'
import CancelIcon from '@mui/icons-material/Cancel'

export interface ActiveFilterChipItem {
  id: string
  label: string
  onRemove?: () => void
}

interface ActiveFilterChipsProps {
  chips: ActiveFilterChipItem[]
  onClearAll: () => void
}

export const ActiveFilterChips: FC<ActiveFilterChipsProps> = ({ chips, onClearAll }) => {
  if (chips.length === 0) return null

  return (
    <Grid container alignItems="center" spacing={1} sx={{ mt: 0.5, mb: 1 }}>
      {chips.map((chip) => (
        <Grid item key={chip.id}>
          <Chip
            label={chip.label}
            variant="outlined"
            onDelete={chip.onRemove}
            deleteIcon={chip.onRemove ? <CancelIcon titleAccess={`Remove filter: ${chip.label}`} /> : undefined}
            sx={{ height: 32 }}
          />
        </Grid>
      ))}
      <Grid item>
        <Button size="small" onClick={onClearAll} sx={{ minHeight: 32 }}>
          Clear all
        </Button>
      </Grid>
    </Grid>
  )
}
